import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Button, Flex, Select, Text } from '@chakra-ui/react';
import moment from 'moment';
import { getSessions } from './api';
import { DatePicker } from '../';
import { downloadFile } from '../../utils/fileDownload';

const SessionSearch = ({ organization, interpreters = [], setSearchResults }) => {
  const { t } = useTranslation();
  const now = moment();
  const monthAgo = moment().subtract(1, 'month');
  const [startDate, setStartDate] = useState(monthAgo.toDate());
  const [endDate, setEndDate] = useState(now.toDate());
  const [interpreter, setInterpreter] = useState(null);
  const onInterpreterChange = useCallback(
    (e) => {
      const int = interpreters.find((i) => i.email === e.target.value);
      if (int) {
        setInterpreter(int);
      }
    },
    [interpreters]
  );

  const onSubmit = useCallback(async () => {
    const start = moment(startDate).format('YYYY-MM-DD');
    const end = moment(endDate).format('YYYY-MM-DD');
    const response = await getSessions(organization, start, end, interpreter && interpreter.email);
    setSearchResults(response, { start, end, interpreter });
  }, [organization, startDate, endDate, interpreter, setSearchResults]);

  const loadExcel = useCallback(async () => {
    const start = moment(startDate).format('YYYY-MM-DD');
    const end = moment(endDate).format('YYYY-MM-DD');
    const loadExcel = true;
    const response = await getSessions(
      organization,
      start,
      end,
      interpreter && interpreter.email,
      loadExcel
    );
    downloadFile(response);
  }, [organization, startDate, endDate, interpreter, setSearchResults]);

  return (
    <Flex
      width="500px"
      bg="brand.110"
      p="3"
      borderRadius="4px"
      alignItems="flex-end"
      flexWrap="wrap"
    >
      <Box mb="3">
        <Flex alignItems="baseline">
          <Text minWidth="120px">{t('organization.search.dateRange')}</Text>
          <Box maxWidth="180px">
            <DatePicker
              isValid={true}
              dateFormat="dd.MM.yyyy"
              placeholderText={t('common.datePlaceholder')}
              selected={startDate}
              endDate={endDate}
              selectsStart
              onChange={setStartDate}
            />
          </Box>
          <Box maxWidth="180px">
            <DatePicker
              isValid={true}
              dateFormat="dd.MM.yyyy"
              placeholderText={t('common.datePlaceholder')}
              selected={endDate}
              startDate={startDate}
              selectsEnd
              onChange={setEndDate}
            />
          </Box>
        </Flex>
        <Flex mt="2" alignItems="baseline">
          <Text minWidth="120px">{t('organization.search.interpreter')}</Text>
          <Select
            bg="white"
            maxWidth="360px"
            placeholder={t('organization.search.all')}
            onChange={onInterpreterChange}
          >
            {interpreters.map((interpreter) => (
              <option key={interpreter.id} value={interpreter.email}>
                {interpreter.name}
              </option>
            ))}
          </Select>
        </Flex>
      </Box>
      <Box flexGrow="1" />
      <Button bg="white" onClick={onSubmit} mr="3">
        {t('organization.search.search')}
      </Button>
      <Button bg="white" onClick={loadExcel}>
        {t('organization.search.download')}
      </Button>
    </Flex>
  );
};

SessionSearch.propTypes = {
  setSearchResults: PropTypes.func,
  organization: PropTypes.string,
  interpreters: PropTypes.array,
};

export default SessionSearch;
